import api from '.';
import { Discipline } from '../pages/MasterData/Discipline/disciplineSlice';
import { Project } from '../pages/Project/projectSlice';
import { User } from '../pages/UserProfile/userProfileSlice';
import { Workflow } from '../pages/MasterData/Workflow/workflowSlice';
import { WorkflowStep } from '../pages/MasterData/WorkflowStep/workflowStepSlice';

export interface WorkflowStepWithCheck
  extends Omit<WorkflowStep, 'projectPositionWorkflowSteps'> {
  isRequired: boolean;
  users: User[];
}
export interface ProjectWorkflow {
  name: string;
  discipline: Discipline | null;
  projectWorkflowSteps: WorkflowStepWithCheck[];
  isCreatorViewOnlyExternal: boolean;
  isCreatorViewOnlyFinal: boolean;
  workflow?: Workflow | null;
}
export interface ProjectWorkflowWithId extends ProjectWorkflow {
  id: number | null;
}
interface GetProjectWorkflows {
  projectId?: number | null;
  sortBy?: string;
  orderBy?: 'desc' | 'asc';
}
interface CreateProjectWorkflow {
  project: Project;
  projectWorkflow: ProjectWorkflow;
}
interface UpdateProjectWorkflow extends CreateProjectWorkflow {
  projectWorkflow: ProjectWorkflowWithId;
}

export async function getProjectWorkflows({
  projectId,
  sortBy,
  orderBy
}: GetProjectWorkflows) {
  const params = {
    projectId,
    sortBy,
    orderBy
  };
  const { data } = await api.get('/project-workflows', { params });
  return data;
}

export async function getProjectWorkflow(id: number) {
  const { data } = await api.get(`/project-workflows/${id}`);
  return data;
}

export async function createProjectWorkflow({
  project,
  projectWorkflow
}: CreateProjectWorkflow) {
  const createProjectWorkflow = {
    name: projectWorkflow.name,
    projectId: project.id,
    disciplineId: projectWorkflow.discipline?.id,
    projectWorkflowSteps: projectWorkflow.projectWorkflowSteps
      .filter((projectWorkflowStep) => projectWorkflowStep.isRequired)
      .map((projectWorkflowStep) => {
        return {
          workflowStepId: projectWorkflowStep.id,
          userIds: projectWorkflowStep.users.map((user) => user.id)
        };
      }),
    isCreatorViewOnlyExternal: projectWorkflow.isCreatorViewOnlyExternal,
    isCreatorViewOnlyFinal: projectWorkflow.isCreatorViewOnlyFinal
  };
  const { data } = await api.post('/project-workflows', createProjectWorkflow);
  return data;
}

export async function updateProjectWorkflow({
  project,
  projectWorkflow
}: UpdateProjectWorkflow) {
  const updateProjectWorkflow = {
    name: projectWorkflow.name,
    projectId: project.id,
    disciplineId: projectWorkflow.discipline?.id,
    projectWorkflowSteps: projectWorkflow.projectWorkflowSteps
      .filter((projectWorkflowStep) => projectWorkflowStep.isRequired)
      .map((projectWorkflowStep) => {
        return {
          projectWorkflowId: projectWorkflow.id,
          workflowStepId: projectWorkflowStep.id,
          userIds: projectWorkflowStep.users.map((user) => user.id)
        };
      }),
    isCreatorViewOnlyExternal: projectWorkflow.isCreatorViewOnlyExternal,
    isCreatorViewOnlyFinal: projectWorkflow.isCreatorViewOnlyFinal
  };
  const { data } = await api.put(
    `/project-workflows/${projectWorkflow.id}`,
    updateProjectWorkflow
  );
  return data;
}

export function deleteProjectWorkflow(id: number) {
  return api.delete(`/project-workflows/${id}`);
}
